import { useQuery } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';
import { IProduct } from '../types/types';

interface IProps {
    customerId: string;
    accountExternalId: string;
    onSuccess: (res: any) => void;
    onError?: (err: string) => void;

}

export const useFetchServiceItems = ({
  customerId, accountExternalId, onSuccess, onError,
}: IProps) => useQuery(
  'useFetchServiceItems',
  async () => {
    const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/invoice/serviceItem`);
    return res.data.invoiceServiceItems;
  },
  {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: (res: IProduct[]) => {
      onSuccess(res);
    },
    onError: (err: Error) => {
      if (onError) {
        onError(err.message);
      }
    },
  },
);
